__turbopack_context__.v({
  "isSelected": "topping-card-module__hvFxBq__isSelected",
  "name": "topping-card-module__hvFxBq__name",
  "price": "topping-card-module__hvFxBq__price",
  "selectedIcon": "topping-card-module__hvFxBq__selectedIcon",
  "toppingCard": "topping-card-module__hvFxBq__toppingCard",
});
